<div class="price-text-wrapper">
    <strong class="label">{{ element.label | htmlDecode }}</strong>
    <ng-container *ngIf="element.type !== 2">
        <ng-container *ngFor="let selection of getSelectedElements()">
            <div class="price-field-wrapper">
                <span class="price-field__name">{{ getSelectionName(selection) }}</span>
                <ng-container *ngIf="element.adminOverrideEligible && element.adminOverride">
                    <div class="price-override-wrapper">
                        <span>{{getCurrencySymbol()}}</span>
                        <sl-input type="number" size='small' [value]="getSelectionValue(selection)" (sl-change)="onChange($event, selection.id, element)"/>
                    </div>
                </ng-container>
                <ng-container *ngIf="!element.adminOverrideEligible || !element.adminOverride">
                    <ng-container *ngIf="selection.displayAdminOverridePrice || selection.displayDiscountCodePrice">
                        <div class="overriden-prices-wrapper">
                            <span class="original-price">{{ getOriginalPrice(selection) }}</span>
                            <span class="discounted-price">{{ getSelectionPrice(selection) }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!selection.displayAdminOverridePrice && !selection.displayDiscountCodePrice">
                        <span>{{ getSelectionPrice(selection) }}</span>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="element.type === 2 && element.currency && element.digitsAfterDecimal !== 0 && element.value.length > 0">
        <div class="price-field-wrapper">
            <span>{{ getTextFromNumberWithCurrency() }}</span>
        </div>
    </ng-container>
    <ng-container *ngIf="element.type === 2 && element.currency && element.digitsAfterDecimal === 0 && element.value.length > 0">
        <div class="price-field-wrapper">
            <span>{{getCurrencySymbol()}}{{ getTextFromNumber() }}</span>
        </div>
    </ng-container>
    <ng-container *ngIf="element.type === 2 && !element.currency && element.value.length > 0">
        <div class="price-field-wrapper">
            <span>{{ getTextFromNumber() }} &times; {{ element.multiplier | currency : '$' }}</span>
            <span>{{ getPriceMultiplied() }}</span>
        </div>
    </ng-container>
</div>